/* eslint-disable no-console,no-template-curly-in-string */
import dotenv from "dotenv";
dotenv.config();

export default class Configuration {
	static get CONFIG () {
		return {
			apiBaseUrl: "$REACT_APP_API_BASE_URL",
			googleMapsApiKey: "$REACT_APP_GOOGLE_MAPS_API_KEY",
			redirectServiceUrl: "$REACT_APP_REDIRECT_SERVICE",
			apiPaymentUrl: "$REACT_APP_API_PAYMENT_URL",
			apiOrderUrl: "$REACT_APP_API_ORDER_URL",
			apiNotificationUrl: "$REACT_APP_API_NOTIFICATION_URL",
			apiCouponUrl: "$REACT_APP_API_COUPONS_URL",
			cssBaseUrl: "$REACT_APP_CSS_BASE_URL",
			// query routing rollout: none | comma-separated dealer/garage/group ids | all
			hpmQueryRouting: "$REACT_APP_HPM_QUERY_ROUTING",
		};
	}

	static value (name) {
		if (!(name in this.CONFIG)) {
			console.log(`Configuration: There is no key named "${name}"`);
			return;
		}

		const value = this.CONFIG[name];

		if (!value) {
			console.log(`Configuration: Value for "${name}" is not defined`);
			return;
		}

		if (value.startsWith("$REACT_APP_")) {
			// value was not replaced, it seems we are in development.
			// Remove $ and get current value from process.env
			const envName = value.substr(1);
			const envValue = process.env[envName];
			if (envValue) {
				return envValue;
			} else {
				console.log(`Configuration: Environment variable "${envName}" is not defined`);
			}
		} else {
			// value was already replaced, it seems we are in production.
			return value;
		}
	}
}
